"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

require("./Dropdown.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomDropdown = function CustomDropdown(_ref) {
  var dropdownList = _ref.dropdownList,
      itemClick = _ref.itemClick,
      selectedItem = _ref.selectedItem,
      title = _ref.title,
      placeholder = _ref.placeholder;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cust-dropdown-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.DropdownButton, {
    placeholder: placeholder,
    id: "dropdown-basic-button",
    title: selectedItem || title || ""
  }, dropdownList && dropdownList.map(function (item, key) {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
      key: key,
      onClick: function onClick() {
        return itemClick(item);
      }
    }, item.title);
  })));
};

var _default = CustomDropdown;
exports.default = _default;